import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi'
import { z } from 'zod'
import { captureAndReturn } from '@omnea-app/packages/universal/zod-utils/captureAndReturn'

extendZodWithOpenApi(z)

export const OverrideIconTypeSchema = z.enum(['bank', 'budget-approval', 'assignees'])
export type OverrideIconType = z.infer<typeof OverrideIconTypeSchema>

export const VisibleIfSchema = z
  .union([
    z.tuple([z.string().uuid()]), // [string]
    z.tuple([]), // []
  ])
  .catch(captureAndReturn('VisibleIfSchema'))

export type VisibleIf = z.infer<typeof VisibleIfSchema>

// 'document' covers both user-uploaded files and scraped URLs — both go through the document extraction pipeline
const AiSourceTypeSchema = z.enum(['document'])

const AiSourceInfoSchema = z.object({
  sourceType: AiSourceTypeSchema.optional(),
  quote: z.string().optional(),
  sourceLabel: z.string(),
  fileStoreId: z.string(),
  sourceUrl: z.string().optional(),
  pageNumber: z.number().optional(),
  heading: z.string().optional(),
  sheetName: z.string().optional(),
})

export const AiCompletionConfidenceSchema = z.enum(['high', 'medium', 'low'])
export type AiCompletionConfidence = z.infer<typeof AiCompletionConfidenceSchema>

const AiCompletionReferenceSchema = z.object({
  title: z.string(),
  url: z.string().url(),
})

const AiCompletionMetadataSchema = z
  .object({
    confidence: AiCompletionConfidenceSchema,
    reasoning: z.string(),
    references: z.array(AiCompletionReferenceSchema).optional(),
  })
  .openapi({
    description:
      'Confidence and reasoning for an answer submitted by the AI Form Completion block. Distinct from aiSources, which tracks document-extraction prefill citations.',
  })

export const FormAnswerMetadataSchema = z.object({
  isAiPrefilled: z.boolean().optional(),
  aiSources: z.array(AiSourceInfoSchema).optional(),
  aiCompletionMetadata: AiCompletionMetadataSchema.optional(),
})

export type FormAnswerMetadata = z.infer<typeof FormAnswerMetadataSchema>

export const BaseFormAnswerSchema = z.object({
  questionId: z.string().nullable(),
  metadata: FormAnswerMetadataSchema.optional(),
})
